// this is a special email-sha used to indicate an already regisetered
// email while avoiding data-protection concerns. As registered
// emails could be used for spoof-mails the backend acts as if the
// user was just registered successfully. But with this special email
// we can still indicate a different text in the frontend to have a
// better user experience - users might wonder why three is no confirmation email.
// Also we can take care of not messing up tracking
export const REGISTERED_SHA256 = 'ad708db673d6d4b15da1d7e12a33d32bc2f08f6b6fa228e43195b607a595ea4c';
